export const defaultJsonSerializer = {
  parse: JSON.parse,
  stringify: JSON.stringify
};